import { getGetAccessTokenProvider, onAuthProviderSet } from './auth'
import { HUB_NAMESPACE } from './constants'
import { Hub } from './election'
import { NotifyService } from './services/notify-service'

// Create a single Hub instance for the application - only on client side
let wsHub: Hub | undefined

export const getWsHub = (): Hub | undefined => {
    // Only create hub in browser environment
    if (typeof window === 'undefined') {
        return undefined
    }

    if (!wsHub) {
        wsHub = new Hub(HUB_NAMESPACE)
        // Attempt registration immediately after creation
        tryRegister()
        // Set up auth provider callback
        onAuthProviderSet(() => tryRegister())
    }

    return wsHub
}

const tryRegister = (): void => {
    const getAccessToken = getGetAccessTokenProvider()
    if (!getAccessToken || !wsHub) return
    wsHub.register(new NotifyService(getAccessToken))
}
